import {
  ChangeDetectionStrategy,
  Component,
  TemplateRef,
  input,
} from "@angular/core";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";
import { NgTemplateOutlet } from "@angular/common";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "vw-select",
  templateUrl: "./select.component.html",
  imports: [ReactiveFormsModule, NgTemplateOutlet],
})
export class SelectComponent {
  readonly label = input<string>();
  readonly id = input<string>();
  readonly items = input<any[]>();
  readonly template = input<TemplateRef<any>>();
  readonly formControlProp = input<string | number>();
  readonly parentForm = input.required<FormGroup>();
  readonly emptyOption = input<boolean>();

  constructor() {}
}
